<template>
  <div
    v-if="listData && listData.length"
    class="theater"
  >
    <h3>剧场版</h3>
    <ul>
      <li
        v-for="(item, index) in listData"
        :key="index"
      >
        <a
          :href="item.url"
          :uigs="`tiny_out_theater_${index}_p`"
          :title="item.name"
        >
          <div class="dt-theater-img">
            <Image-1 :src="item.picurl" />
            <span class="tag-mark">{{ item.score && item.score.length === 1 ? item.score + '.0' : item.score }}</span>
          </div>
          <p class="theater-name">{{ item.name }}</p>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Image from './Image.vue';

export default {
  components: {
    'Image-1': Image,
  },
  computed: {
    ...mapState('detail', ['itemData']),
    listData() {
      return this.itemData.theaterData || [];
    },
  },
};
</script>
<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';
.theater {
  overflow: hidden;
  margin: 23px 0;
  h3 {
    height: 25px;
    font-size: 17px;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
    line-height: 25px;
    padding: 0 14px;
  }
  ul {
    display: flex;
    flex-wrap: nowrap;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    padding: 0 14px;
    transform: translateY(11px);
    li {
      display: inline-block;
      width: 32%;
      margin-right: 2%;
      vertical-align: text-top;
      flex: none;
      padding-bottom: 11px;
      .theater-name {
        font-size: 15px;
        color: rgba(0, 0, 0, 1);
        line-height: 21px;
        margin-top: 6px;
        @include line-clip(2);
      }
      &:last-child {
        padding-right: 14px;
      }
    }
  }
}
.dt-theater-img {
  width: 100%;
  padding-top: 140%;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  &:after {
    content: '';
    width: 100%;
    height: 50px;
    position: absolute;
    bottom: 0;
    left: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  > span {
    position: absolute;
    display: block;
  }
  .tag-mark {
    right: 8px;
    bottom: 10px;
    color: #fece32;
    font-size: 13px;
    z-index: 2;
    font-weight: bold;

    &:first-letter {
      font-size: 19px;
    }
  }
}
</style>
